var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', [_vm._l(_vm.shaderList, function (item, index) {
    return [_c('FormPanel', { key: index, attrs: { "title": item.title } }, [_c('el-form', { staticClass: "el-form-panel", nativeOn: { "submit": function submit($event) {
          $event.preventDefault();
        } } }, [!_vm.isShowColorPicker(item.prop) ? _c('div', { staticClass: "panel-rows" }, [_c('el-schema-form-item', { staticClass: "left-column", attrs: { "form-item": item.formItem, "model": _vm.shaderModel, "prop": item.prop }, on: { "change": _vm.handleChange } }), _vm._v(" "), _c('el-form-item', { staticClass: "custom-number-form-item", attrs: { "label": "" } }, [_c('el-input-number', { attrs: { "value": _vm.shaderModel[item.prop], "min": item.formItem.field.min, "max": item.formItem.field.max, "step": item.formItem.field.step, "controls": false, "step-strictly": true, "precision": 2 }, on: { "change": function change($event) {
          return _vm.handleChange({
            prop: item.prop,
            value: $event
          });
        } } })], 1)], 1) : _c('div', [_c('model-color-picker', { attrs: { "format": "rgba", "color": [_vm.shaderModel[item.prop][0], _vm.shaderModel[item.prop][1], _vm.shaderModel[item.prop][2], _vm.shaderModel[item.prop][3]] }, on: { "changeColor": function changeColor(color) {
          _vm.handleChange({
            prop: item.prop,
            value: color
          });
        } } })], 1)]), _vm._v(" "), _c('template', { slot: "action-bar" }, [_c('reset-resource', { attrs: { "category-id": 0 }, on: { "reset": function reset($event) {
          return _vm.handleReset({ prop: item.prop });
        } } })], 1)], 2)];
  })], 2);
};
var staticRenderFns = [];

export { render, staticRenderFns };